module.exports = __webpack_public_path__ + "static/media/veteranaffairs.ddd1d680.png";